export default {
  methods: {
    mapLayerWintertrailsLandmarksAdd() {
      this.initPollWintertrailsLandmarks();
      this.map.addSource("wintertrails-landmarks-source", {
        type: "geojson",
        data: this.computedWintertrailsLandmarksGeoJson
      });

      // Triangle point
      this.map.loadImage(
        "https://d1upyp0je0gcjj.cloudfront.net/wintertrails/landmarks/triangle.png",
        (error, image) => {
          this.map.addImage("icon-wintertrails-landmarks-triangle", image);
          this.map.addLayer({
            filter: ["==", "class", 1],
            id: "wintertrails-landmarks-triangle",
            type: "symbol",
            source: "wintertrails-landmarks-source",
            layout: {
              "icon-image": "icon-wintertrails-landmarks-triangle",
              "icon-size": 0.1,
              "icon-allow-overlap": true
            }
          });
          this.map.moveLayer(
            "wintertrails-landmarks-triangle",
            "marker-layer-points"
          );
        }
      );

      // Circle point
      this.map.loadImage(
        "https://d1upyp0je0gcjj.cloudfront.net/wintertrails/landmarks/circle2.png",
        (error, image) => {
          this.map.addImage("icon-wintertrails-landmarks-circle", image);
          this.map.addLayer({
            filter: ["==", "class", 2],
            id: "wintertrails-landmarks-circle",
            type: "symbol",
            source: "wintertrails-landmarks-source",
            layout: {
              "icon-image": "icon-wintertrails-landmarks-circle",
              "icon-size": 0.1,
              "icon-allow-overlap": true
            }
          });
          this.map.moveLayer(
            "wintertrails-landmarks-circle",
            "marker-layer-points"
          );
        }
      );

      // Weatherpoint
      this.map.loadImage(
        "https://d1upyp0je0gcjj.cloudfront.net/wintertrails/landmarks/weather.png",
        (error, image) => {
          this.map.addImage("icon-wintertrails-landmarks-weather", image);
          this.map.addLayer({
            filter: ["==", "class", 3],
            id: "wintertrails-landmarks-weather",
            type: "symbol",
            source: "wintertrails-landmarks-source",
            layout: {
              "icon-image": "icon-wintertrails-landmarks-weather",
              "icon-size": 0.1,
              "icon-allow-overlap": true
            }
          });
          this.map.moveLayer(
            "wintertrails-landmarks-weather",
            "marker-layer-points"
          );
        }
      );
    },
    mapLayerWintertrailsLandmarksRemove() {
      this.cancelPollWintertrailsLandmarks();
      this.map.removeImage("icon-wintertrails-landmarks-triangle");
      this.map.removeImage("icon-wintertrails-landmarks-circle");
      this.map.removeImage("icon-wintertrails-landmarks-weather");
      this.map.removeLayer("wintertrails-landmarks-triangle");
      this.map.removeLayer("wintertrails-landmarks-circle");
      this.map.removeLayer("wintertrails-landmarks-weather");
      this.map.removeSource("wintertrails-landmarks-source");
    },
    initPollWintertrailsLandmarks() {
      this.$store.dispatch("actionGetGeoJson", {
        url:
          "https://api2.alchemymapping.com/vail/whistler/wintertrails/landmarks",
        dept: "wintertrails",
        layer: "landmarks",
        token: this.computedAuthToken
      });
      this.pollwintertrailsSewergaspointsInterval = setInterval(() => {
        this.$store.dispatch("actionGetGeoJson", {
          url:
            "https://api2.alchemymapping.com/vail/whistler/wintertrails/landmarks",
          dept: "wintertrails",
          layer: "landmarks",
          token: this.computedAuthToken
        });
      }, this.computedInterval);
    },
    cancelPollWintertrailsLandmarks() {
      this.pollWintertrailsLandmarksInterval = clearInterval(
        this.pollWintertrailsLandmarksInterval
      );
    }
  },
  computed: {
    computedWintertrailsLandmarksGeoJson() {
      return this.$store.state.mapLayers.wintertrails.layers.landmarks.geojson;
    },
    computedWintertrailsLandmarksMapVisibility() {
      return this.$store.state.mapLayers.wintertrails.layers.landmarks
        .visibility.mapView;
    },
    computedAuthToken() {
      return this.$store.state.auth.token;
    },
    computedInterval() {
      return this.$store.state.general.intervalLow;
    }
  },
  watch: {
    "$store.state.mapLayers.wintertrails.layers.landmarks.geojson": {
      handler() {
        if (this.computedWintertrailsLandmarksGeoJson) {
          this.mapLayerWintertrailsLandmarksRemove();
          this.mapLayerWintertrailsLandmarksAdd();
        }
      }
    },
    "$store.state.mapLayers.wintertrails.layers.landmarks.visibility.mapView": function(
      newValue
    ) {
      if (newValue) {
        this.mapLayerWintertrailsLandmarksAdd();
      } else {
        this.mapLayerWintertrailsLandmarksRemove();
      }
    }
  },
  beforeDestroy() {
    this.cancelPollWintertrailsLandmarks();
  }
};
